import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';
import { combineReducers } from 'redux';

import routes from './routeReducers';
import layout from './layout';
import polling from './polling';

const customizer = (objValue, srcValue) => {
  if (isArray(srcValue) && srcValue.length === 0) {
    return srcValue;
  }

  return undefined;
};

const entities = (state = {}, action) => {
  if (action.response && action.response.entities) {
    const keys = Object.keys(action.response.entities);
    const clearLatest = {};

    if (
      keys.length === 1 &&
      action.response.entities[keys[0]].hasOwnProperty('latest')
    ) {
      clearLatest[keys[0]] = { latest: null };
    }

    return mergeWith(
      {},
      state,
      { suggestions: {}, ...clearLatest },
      action.response.entities,
      customizer,
    );
  }

  return state;
};

const appReducer = combineReducers({
  entities,
  routes,
  layout,
  polling,
});

const rootReducer = (state, action) => {
  let appState = state;

  return appReducer(appState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js